module.exports = __webpack_public_path__ + "static/media/plate.5e2c9034.svg";